import { render } from "./VScript.vue?vue&type=template&id=50e5ce54"
import script from "./VScript.vue?vue&type=script&lang=js"
export * from "./VScript.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/VScript.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50e5ce54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50e5ce54', __exports__)) {
    api.reload('50e5ce54', __exports__)
  }
  
  module.hot.accept("./VScript.vue?vue&type=template&id=50e5ce54", () => {
    api.rerender('50e5ce54', render)
  })

}


export default __exports__